// object to store loaded and loading wasm modules
var installedWasmModules = {};

function promiseResolve() { return Promise.resolve(); }

var wasmImportedFuncCache0;
var wasmImportedFuncCache1;
var wasmImportedFuncCache2;
var wasmImportedFuncCache3;
var wasmImportedFuncCache4;
var wasmImportedFuncCache5;
var wasmImportedFuncCache6;
var wasmImportedFuncCache7;
var wasmImportedFuncCache8;
var wasmImportedFuncCache9;
var wasmImportedFuncCache10;
var wasmImportedFuncCache11;
var wasmImportedFuncCache12;
var wasmImportedFuncCache13;
var wasmImportedFuncCache14;
var wasmImportedFuncCache15;
var wasmImportedFuncCache16;
var wasmImportedFuncCache17;
var wasmImportedFuncCache18;
var wasmImportedFuncCache19;
var wasmImportedFuncCache20;
var wasmImportedFuncCache21;
var wasmImportedFuncCache22;
var wasmImportedFuncCache23;
var wasmImportedFuncCache24;
var wasmImportedFuncCache25;
var wasmImportedFuncCache26;
var wasmImportedFuncCache27;
var wasmImportedFuncCache28;
var wasmImportedFuncCache29;
var wasmImportedFuncCache30;
var wasmImportedFuncCache31;
var wasmImportedFuncCache32;
var wasmImportedFuncCache33;
var wasmImportedFuncCache34;
var wasmImportedFuncCache35;
var wasmImportedFuncCache36;
var wasmImportedFuncCache37;
var wasmImportedFuncCache38;
var wasmImportObjects = {
	"../../../../node_modules/blake3/dist/wasm/browser/blake3_js_bg.wasm": function() {
		return {
			"./blake3_js_bg.js": {
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache0 === undefined) wasmImportedFuncCache0 = __webpack_require__.c["../../../../node_modules/blake3/dist/wasm/browser/blake3_js_bg.js"].exports;
					return wasmImportedFuncCache0["Or"](p0i32,p1i32);
				}
			}
		};
	},
	"../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.wasm": function() {
		return {
			"./matched_data_wasm_bg.js": {
				"__wbg_self_86b4b13392c7af56": function() {
					if(wasmImportedFuncCache1 === undefined) wasmImportedFuncCache1 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache1["U5"]();
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache2 === undefined) wasmImportedFuncCache2 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache2["ug"](p0i32);
				},
				"__wbg_static_accessor_MODULE_452b4680e8614c81": function() {
					if(wasmImportedFuncCache3 === undefined) wasmImportedFuncCache3 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache3["DA"]();
				},
				"__wbg_require_f5521a5b85ad2542": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache4 === undefined) wasmImportedFuncCache4 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache4["r2"](p0i32,p1i32,p2i32);
				},
				"__wbg_crypto_b8c92eaac23d0d80": function(p0i32) {
					if(wasmImportedFuncCache5 === undefined) wasmImportedFuncCache5 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache5["iY"](p0i32);
				},
				"__wbg_msCrypto_9ad6677321a08dd8": function(p0i32) {
					if(wasmImportedFuncCache6 === undefined) wasmImportedFuncCache6 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache6["mS"](p0i32);
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache7 === undefined) wasmImportedFuncCache7 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache7["XP"](p0i32);
				},
				"__wbg_getRandomValues_dd27e6b0652b3236": function(p0i32) {
					if(wasmImportedFuncCache8 === undefined) wasmImportedFuncCache8 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache8["yX"](p0i32);
				},
				"__wbg_newwithlength_e0c461e90217842c": function(p0i32) {
					if(wasmImportedFuncCache9 === undefined) wasmImportedFuncCache9 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache9["Ar"](p0i32);
				},
				"__wbg_subarray_8a52f1c1a11c02a8": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache10 === undefined) wasmImportedFuncCache10 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache10["kT"](p0i32,p1i32,p2i32);
				},
				"__wbg_getRandomValues_e57c9b75ddead065": function(p0i32,p1i32) {
					if(wasmImportedFuncCache11 === undefined) wasmImportedFuncCache11 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache11["ae"](p0i32,p1i32);
				},
				"__wbg_length_2cfa674c2a529bc1": function(p0i32) {
					if(wasmImportedFuncCache12 === undefined) wasmImportedFuncCache12 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache12["oI"](p0i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache13 === undefined) wasmImportedFuncCache13 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache13["oH"]();
				},
				"__wbg_buffer_e35e010c3ba9f945": function(p0i32) {
					if(wasmImportedFuncCache14 === undefined) wasmImportedFuncCache14 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache14["YY"](p0i32);
				},
				"__wbg_new_139e70222494b1ff": function(p0i32) {
					if(wasmImportedFuncCache15 === undefined) wasmImportedFuncCache15 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache15["xb"](p0i32);
				},
				"__wbg_set_d771848e3c7935bb": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache16 === undefined) wasmImportedFuncCache16 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache16["fZ"](p0i32,p1i32,p2i32);
				},
				"__wbg_randomFillSync_d2ba53160aec6aba": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache17 === undefined) wasmImportedFuncCache17 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache17["Os"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_json_parse": function(p0i32,p1i32) {
					if(wasmImportedFuncCache18 === undefined) wasmImportedFuncCache18 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache18["t$"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache19 === undefined) wasmImportedFuncCache19 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache19["Or"](p0i32,p1i32);
				}
			}
		};
	},
	"../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.wasm": function() {
		return {
			"./matched_data_wasm_bg.js": {
				"__wbg_self_86b4b13392c7af56": function() {
					if(wasmImportedFuncCache20 === undefined) wasmImportedFuncCache20 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache20["U5"]();
				},
				"__wbindgen_object_drop_ref": function(p0i32) {
					if(wasmImportedFuncCache21 === undefined) wasmImportedFuncCache21 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache21["ug"](p0i32);
				},
				"__wbg_static_accessor_MODULE_452b4680e8614c81": function() {
					if(wasmImportedFuncCache22 === undefined) wasmImportedFuncCache22 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache22["DA"]();
				},
				"__wbg_require_f5521a5b85ad2542": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache23 === undefined) wasmImportedFuncCache23 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache23["r2"](p0i32,p1i32,p2i32);
				},
				"__wbg_crypto_b8c92eaac23d0d80": function(p0i32) {
					if(wasmImportedFuncCache24 === undefined) wasmImportedFuncCache24 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache24["iY"](p0i32);
				},
				"__wbg_msCrypto_9ad6677321a08dd8": function(p0i32) {
					if(wasmImportedFuncCache25 === undefined) wasmImportedFuncCache25 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache25["mS"](p0i32);
				},
				"__wbindgen_is_undefined": function(p0i32) {
					if(wasmImportedFuncCache26 === undefined) wasmImportedFuncCache26 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache26["XP"](p0i32);
				},
				"__wbg_getRandomValues_dd27e6b0652b3236": function(p0i32) {
					if(wasmImportedFuncCache27 === undefined) wasmImportedFuncCache27 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache27["yX"](p0i32);
				},
				"__wbg_newwithlength_e0c461e90217842c": function(p0i32) {
					if(wasmImportedFuncCache28 === undefined) wasmImportedFuncCache28 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache28["Ar"](p0i32);
				},
				"__wbg_subarray_8a52f1c1a11c02a8": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache29 === undefined) wasmImportedFuncCache29 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache29["kT"](p0i32,p1i32,p2i32);
				},
				"__wbg_getRandomValues_e57c9b75ddead065": function(p0i32,p1i32) {
					if(wasmImportedFuncCache30 === undefined) wasmImportedFuncCache30 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache30["ae"](p0i32,p1i32);
				},
				"__wbg_length_2cfa674c2a529bc1": function(p0i32) {
					if(wasmImportedFuncCache31 === undefined) wasmImportedFuncCache31 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache31["oI"](p0i32);
				},
				"__wbindgen_memory": function() {
					if(wasmImportedFuncCache32 === undefined) wasmImportedFuncCache32 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache32["oH"]();
				},
				"__wbg_buffer_e35e010c3ba9f945": function(p0i32) {
					if(wasmImportedFuncCache33 === undefined) wasmImportedFuncCache33 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache33["YY"](p0i32);
				},
				"__wbg_new_139e70222494b1ff": function(p0i32) {
					if(wasmImportedFuncCache34 === undefined) wasmImportedFuncCache34 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache34["xb"](p0i32);
				},
				"__wbg_set_d771848e3c7935bb": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache35 === undefined) wasmImportedFuncCache35 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache35["fZ"](p0i32,p1i32,p2i32);
				},
				"__wbg_randomFillSync_d2ba53160aec6aba": function(p0i32,p1i32,p2i32) {
					if(wasmImportedFuncCache36 === undefined) wasmImportedFuncCache36 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache36["Os"](p0i32,p1i32,p2i32);
				},
				"__wbindgen_json_parse": function(p0i32,p1i32) {
					if(wasmImportedFuncCache37 === undefined) wasmImportedFuncCache37 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache37["t$"](p0i32,p1i32);
				},
				"__wbindgen_throw": function(p0i32,p1i32) {
					if(wasmImportedFuncCache38 === undefined) wasmImportedFuncCache38 = __webpack_require__.c["../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.js"].exports;
					return wasmImportedFuncCache38["Or"](p0i32,p1i32);
				}
			}
		};
	},
};

var wasmModuleMap = {
	"9294": [
		"../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.wasm"
	],
	"66756": [
		"../../../../node_modules/blake3/dist/wasm/browser/blake3_js_bg.wasm"
	],
	"75430": [
		"../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.wasm"
	]
};

// object with all WebAssembly.instance exports
__webpack_require__.w = {};

// Fetch + compile chunk loading for webassembly
__webpack_require__.f.wasm = function(chunkId, promises) {

	var wasmModules = wasmModuleMap[chunkId] || [];

	wasmModules.forEach(function(wasmModuleId, idx) {
		var installedWasmModuleData = installedWasmModules[wasmModuleId];

		// a Promise means "currently loading" or "already loaded".
		if(installedWasmModuleData)
			promises.push(installedWasmModuleData);
		else {
			var importObject = wasmImportObjects[wasmModuleId]();
			var req = fetch(__webpack_require__.p + "" + {"9294":{"../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.wasm":"cb8a3a594a8d3d2fdcb9"},"66756":{"../../../../node_modules/blake3/dist/wasm/browser/blake3_js_bg.wasm":"d7ee08b024fbde688949"},"75430":{"../../../../node_modules/@cloudflare/matched_data_wasm/matched_data_wasm_bg.wasm":"cb8a3a594a8d3d2fdcb9"}}[chunkId][wasmModuleId] + ".module.wasm");
			var promise;
			if(importObject && typeof importObject.then === 'function' && typeof WebAssembly.compileStreaming === 'function') {
				promise = Promise.all([WebAssembly.compileStreaming(req), importObject]).then(function(items) {
					return WebAssembly.instantiate(items[0], items[1]);
				});
			} else if(typeof WebAssembly.instantiateStreaming === 'function') {
				promise = WebAssembly.instantiateStreaming(req, importObject);
			} else {
				var bytesPromise = req.then(function(x) { return x.arrayBuffer(); });
				promise = bytesPromise.then(function(bytes) {
					return WebAssembly.instantiate(bytes, importObject);
				});
			}
			promises.push(installedWasmModules[wasmModuleId] = promise.then(function(res) {
				return __webpack_require__.w[wasmModuleId] = (res.instance || res).exports;
			}));
		}
	});
};